module.exports = __webpack_public_path__ + "static/media/areas05M.59f5e0c6.jpg";